import DigitalDonationReceiptFormDefinitionResourceModel from '../../generated/types/model/resource/DigitalDonationReceiptFormDefinitionResourceModel';

export default class DigitalDonationReceiptFormDefinitionResourceViewModel extends DigitalDonationReceiptFormDefinitionResourceModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
